import produce from 'immer';
import { createPropsFinder, createPropsSelector } from './utils';

export const selectDayKinds = (state) => state.bo.dayKinds.dayKinds || produce([], () => {});

export const selectDayKindsByProps = createPropsSelector(selectDayKinds);
export const findDayKindsByProps = createPropsFinder(selectDayKinds);
